import { faAngleDown, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { Button, FormCheck } from 'react-bootstrap';
import { DataTableColumn } from './DataTable';

interface IRow<T> {
  data: T;
  columns: DataTableColumn<T>[];
  collapsible?: (row: T) => React.ReactNode | null;
  hasPrependCol: boolean;
  isRowCollapsible?: boolean;
  onSelect?: (checked: boolean) => void;
  selectable?: boolean;
  selected?: boolean;
}

const Row = <T extends Record<string, unknown>>(props: IRow<T>) => {
  const [collapsed, setCollapsed] = useState(true);
  const { collapsible } = props;
  let collapsibleContent;
  if (collapsible) {
    collapsibleContent = collapsible(props.data);
  }

  const handleSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onSelect) {
      props.onSelect(event.target.checked);
    }
  };

  const check = props.selectable ? (
    <FormCheck
      onChange={handleSelect}
      className='d-inline-block mr-3'
      checked={props.selected}
    />
  ) : null;

  return (
    <React.Fragment>
      <tr>
        {collapsibleContent && (
          <>
            <td>
              {check}
              {collapsed ? (
                <Button
                  variant='light'
                  className='py-0'
                  onClick={() => setCollapsed(false)}
                >
                  <FontAwesomeIcon icon={faAngleRight} />
                </Button>
              ) : (
                <Button
                  variant='light'
                  className='py-0'
                  onClick={() => setCollapsed(true)}
                >
                  <FontAwesomeIcon icon={faAngleDown} />
                </Button>
              )}
            </td>
          </>
        )}
        {
          // If the table is collapsible and there is not any collapsible
          // content for this row, we need an empty cell to replace the up-arrow and down-arrow cell.
          props.hasPrependCol && !collapsibleContent && (
            <td>
              {check}
              <div style={{ width: '25px' }} />
            </td>
          )
        }
        {props.columns.map((c) => {
          let content = null;
          if ('render' in c && c.render) {
            content = c.render(props.data);
          } else if ('selector' in c && c.selector) {
            content = props.data[c.selector] as React.ReactNode;
          }
          return (
            <td key={c.name} style={{ width: c.width }} className={c.className}>
              {content}
            </td>
          );
        })}
      </tr>
      {collapsibleContent &&
        !collapsed &&
        (props.isRowCollapsible ? (
          collapsibleContent
        ) : (
          <tr>
            <td style={{ border: 'none' }} colSpan={props.columns.length + 1}>
              {collapsibleContent}
            </td>
          </tr>
        ))}
    </React.Fragment>
  );
};

export default Row;
